<app-recommendations-cards [categories]="categories$ | async"></app-recommendations-cards>
